import { DiscountVisitType } from '../enums';

export class DiscountVisitTypeLookup {
    static get(): any[] {
        return [
            { label: 'Credit', value: DiscountVisitType.Credit },
            { label: 'Cash', value: DiscountVisitType.Cash },
            { label: 'Both', value: DiscountVisitType.Both }];
    }

    static byId(id: number): any {

        this.get()?.find(f => f.value === +id);
    }
}
